<template>
  <div class="container mx-auto">
    <form @submit.prevent="updateComment">
            <div class="mb-4 py-4 mx-2" >
                <div class="">
                   <div class="ml-4 mb-2">
                        <label for="username" class="block text-gray-700 text-sm font-bold mb-2">TITULLI</label>
                    <input v-model="commentForUser.title" class="shadow appearance-none border rounded w-auto py-2 px-3 
                     text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                    </div>
                     <div class="ml-4 mb-2">
                        <label for="username" class="block text-gray-700 text-sm font-bold mb-2">KATEGORIA</label>
                    <select v-model="commentForUser.category" class="shadow appearance-none border rounded w-auto py-2 px-3 
                     text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                      <option value="mungese_performance">Mungese performance</option>
                      <option value="minus">MINUS</option>
                      <option value="tjera">TJERA</option>
                    </select>
                    </div>
                     <div class="ml-4 mb-2">
                        <label for="username" class="block text-gray-700 text-sm font-bold mb-2">VLERA</label>
                    <input v-model="commentForUser.value" class="shadow appearance-none border rounded w-auto py-2 px-3 
                     text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                    </div>
                    <div class="ml-4 mb-2">
                        <label for="username" class="block text-gray-700 text-sm font-bold mb-2">KOMENTI</label>
                    <textarea v-model="commentForUser.comment" class="shadow appearance-none border rounded w-auto py-2 px-3 
                     text-gray-700 leading-tight focus:outline-none focus:shadow-outline" cols="20" rows="4">
                    </textarea>
                    </div>
                    <div class="ml-3 mt-4" >
                        <button type="submit" @click="updateComment" class="block text-center uppercase focus:outline-none shadow bg-teal-400 
                        hover:bg-teal-300 text-white text-xs py-2 px-5 rounded mb-2">
                            Ruaj ndryshimet
                        </button>
                    </div>
                </div>
            </div>
      
    </form>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      commentForUser: {},
      users: [],
      user_id: this.$route.params.user_id,
      id: this.$route.params.id,
      user: null,
      isAdmin: false,
    };
  },
  created() {
    // this.getUsers();

    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    axios.get(`${process.env.VUE_APP_API}/user`).then((response) => {
      if (response.data.data.is_admin) {
        this.isAdmin = true;
      } else {
        this.isAdmin = false;
      }

        this.getAllComments();
      // console.log(this.date);
      // console.log(this.formatDate(this.date));
    });
  },
  methods: {
     getAllComments() {
            axios
            .get(`${process.env.VUE_APP_API}/getOne/comment-for-user/${this.id}`)
            .then((response) => {
                this.commentForUser = response.data;
                //this.user_id = response.data[0].user_id;
                console.log(response.data.comment);
            })
            .catch((error) => console.log(error));
    },
    updateComment() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .put(`${process.env.VUE_APP_API}/comment-for-user/${this.id}`, {
             user_id: this.user_id,
             name: this.commentForUser.name,
             comment: this.commentForUser.comment,
             title: this.commentForUser.title,
             category: this.commentForUser.category,
             value: this.commentForUser.value
        })
        .then(() => {
          console.log(this.commentForUser.value);
          this.$router.push("/finished-tasks");
          //   console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style></style>
